import * as React from 'react';
import {
  useDefaultLayout,
  type Layout,
  type LayoutChangedMeta,
  type LayoutStorage,
} from 'react-resizable-panels';

const NO_STORAGE: LayoutStorage = { getItem: () => null, setItem: () => undefined };

type UsePersistedPanelLayoutOptions = Readonly<{
  autoSaveId: string | undefined;
  leftPaneVisible: boolean;
  rightPaneVisible: boolean;
}>;

export function usePersistedPanelLayout({
  autoSaveId,
  leftPaneVisible,
  rightPaneVisible,
}: UsePersistedPanelLayoutOptions) {
  const { defaultLayout, onLayoutChanged: saveLayout } = useDefaultLayout({
    id: autoSaveId ?? 'dime-detail-layout',
    panelIds: [
      ...(leftPaneVisible ? ['left'] : []),
      'record',
      ...(rightPaneVisible ? ['right'] : []),
    ],
    storage: autoSaveId ? undefined : NO_STORAGE,
  });

  // A pane dragged shut unmounts, so saving its 0% would reopen it at zero width.
  const onLayoutChanged = React.useCallback(
    (layout: Layout, meta: LayoutChangedMeta) => {
      if (Object.values(layout).includes(0)) return;
      saveLayout(layout, meta);
    },
    [saveLayout],
  );

  return { defaultLayout, onLayoutChanged };
}
